export default __webpack_public_path__ + "static/media/Snd_ClowerO.cf47d0e2.mp3";